import React from 'react'
import bg from "../images/IMG_0095.jpg";
import Content from '../components/Content'
import Button from '../components/Button'
import {OFFER} from "../constant"
import Footer from '../components/Footer'
import Nav from '../components/Nav'
import restaraunt1 from "../images/restaraunt1.JPG"
import restaraunt2 from "../images/restaraunt2.JPG"
import birthday from "../images/birthday2.JPG"
export const images=[restaraunt1,restaraunt2,birthday]
const Offer = () => {
  return (
    <div>
       
        <div className="h-3/4 bg bg-cover bg-center">
        <div className="h-full z-10 overlay">
          <Nav/>
          <div className="container landing mx-auto z-10 text-center text-white">
            <p className="text-4xl">OFFERS</p>
          </div>
          </div>
          </div>
        {OFFER.map((e,i)=>{
    
            return(
 <div key={i} className="shadow-lg m-5 container mx-auto md:grid grid-rows-1 grid-cols-2 gap-4 grid-flow-row sm:flex flex-col">
<div className="bg-cover place-self-center">
            <img src={images[i]} alt="bg"/>
          </div>
          <div className="text-black sm:p-10 place-self-center">
            <Content isColor={true} title="Offers"
            subtitle="Restaurant"
            content="Be The First One To Know About It"/>
            <div className=" p-2 text-black text-xl">We’re changing the rules of the game! We’re constantly coming up with great
promotions designed especially for your needs. Our time-limited and carefully craftedfor-
you promotions enable you to enjoy a great deal on your favorite meals everytime
you simply don’t feel like cooking</div>
            <div className=" p-2 text-black text-xl"><strong>Free Delivery Service</strong></div>
            <div className=" pl-2 text-black text-lg">{e.service}</div>
            <div className=" p-2 text-black text-xl"><strong>Conditions</strong></div>
            <div className=" pl-2 text-black text-lg">{e.price}</div>
            <div className=" pl-2 pb-4 text-black text-lg">{e.payment}</div>
            <div className="flex flex-wrap justify-between p-4 text-black border border-transparent border-t-gray-100">
    <p className="place-self-center font-semibold text-xl">VIEW TERMS & CONDITIONS</p>
    <Button isColour={true} label='BOOK NOW'/></div>
          </div>
          
          </div>
            )})
            }
        <Footer/>
    </div>
  )
}

export default Offer